import { setCookieToken } from './setTokenCookie/setCookieToken';

// Exchanges a subscriber token for the current subscription and keeps it as the session cookie on success.
const exchangeSubscriptionToken = (token: string, isProdEnv?: boolean): Promise<Response> =>
  fetch('/current_subscription', {
    method: 'POST',
    headers: {
      'Sec-Fetch-Dest': 'empty',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ jwt_token: token }),
  }).then((response) => {
    if (response.ok) {
      document.cookie = setCookieToken({ key: 'token', token, isProdEnv });
    }
    return response;
  });

export default exchangeSubscriptionToken;
